import styled from "@emotion/styled";

import { theme } from "../ThemeProvider/CandyTheme/ThemeShorthand";

export const Circle = styled.div(props => ({
    display: "inline-flex",
    cursor: "pointer",
    height: 41,
    width: 41,
    borderRadius: `20.5px`,
    boxShadow: `1px 4px 8px ${theme(props).legacy.shadowColor}`,
    backgroundColor: theme(props).brandColors.primaryColor,
}));

export const PositionAdjustBlock = styled.div(props => ({
    position: "relative",
    color: theme(props).invertedColors.color,
    top: 3,
    left: 3,
}));
